import React, { ChangeEventHandler, FC } from "react";
import { Input, InputProps } from "antd";
import "./Input.scss";
import cn from "classnames";
import Tag from "../../Tag";

type AntInputProps = InputProps & {
	loading?: boolean;
	label?: React.ReactNode;
	isSearch?: boolean;
	disabled?: boolean;
	caption?: string;
	isSuccess?: boolean;
	isError?: boolean;
	successMsg?: string;
	inputClass?: string;
	inputType?: "default" | "primary" | any;
	size?: "small" | "middle" | "large" | undefined;
	searchType?: "primary" | "secondary" | undefined;
	rows?: number;
	value?: any;
	onSearch?: any;
	isTextArea?: boolean;
	onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
	background?: string;
	addonBefore?: any;
	errorMessage?: string;
	errorMsg?: any;
	[key: string]: any;
};

const AntInput: FC<AntInputProps> = React.forwardRef(
	(
		{
			isSearch,
			onSearch,
			label,
			caption,
			isSuccess,
			isError,
			successMsg,
			value,
			size = "large",
			inputType = "primary",
			searchType = "primary",
			inputClass,
			isTextArea,
			background,
			onChange,
			rows,
			defaultValue,
			addonBefore,
			errorMessage,
			errorMsg,
			...props
		},
		ref
	) => {
		const { Search, TextArea } = Input;

		const classNames = cn(
			"input",
			searchType === "primary" && "search-primary",
			searchType === "secondary" && "search-secondary",
			inputType === "default" && "default",
			isSuccess && "is-success",
			isError && "is-error",
			errorMsg && "ant-form-item-has-error",
			size && size
		);

		// @ts-ignore

		return (
			<>
				<div className={classNames}>
					{label && <span className={"input-label"}>{label}</span>}
					{isSearch ? (
						<Search {...props} value={value} onSearch={onSearch} onChange={onChange} size={size} type={"search"} />
					) : isTextArea ? (
						//@ts-ignore
						<TextArea
							defaultValue={defaultValue}
							className={inputClass}
							//@ts-ignore
							onChange={onChange}
							addonBefore={addonBefore}
							rows={rows}
							value={value}
							{...props}
						/>
					) : (
						<Input
							defaultValue={defaultValue}
							size={size}
							onChange={onChange}
							className={inputClass}
							value={value}
							addonBefore={addonBefore}
							style={{
								...props?.style,
								color: "#000",
								fontWeight: 800,
								background: background
							}}
							{...props}
						/>
					)}
					{caption && <small>{caption}</small>}
					{successMsg && <Tag title={successMsg} type={"success"} />}
					{errorMessage && <Tag title={errorMessage} type={"error"} />}
					{errorMsg && <Tag title={errorMsg} type="error" />}
				</div>
			</>
		);
	}
);

export default AntInput;
